<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="franchiseUser" class="flex flex-col">
        <div class="card">
          <card-header :title="'Usuario #' + franchiseUser.id">
            <template #actions>
              <router-link
                v-if="hasPermission('edit_users') && !franchiseUser.is_super"
                :to="{
                  name: 'usersEditForm',
                  params: { id: franchiseUser.id },
                }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_users') && !franchiseUser.is_super"
                @click="openDeleteModal()"
              />
            </template>
          </card-header>

          <div class="detail-grid">
            <detail-field label="Nombre" :value="franchiseUser.name + ' ' + franchiseUser.last_name" />
            <detail-field label="Rol" :value="franchiseUser.is_super ? 'Super Admin' : franchiseUser.user.role.name" />
            <detail-field label="Correo" :value="franchiseUser.user.email" />
            <detail-field label="Fecha de creación" :value="formatDatetime(franchiseUser.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(franchiseUser.updated_at)" />
          </div>

          <section-header title="Sucursales asignadas" />
          <p
            class="detail-value"
            v-for="branch in franchiseUser.branches"
            :key="branch.id"
          >
            - {{ branch.name }}
          </p>
          <p v-if="franchiseUser.is_super" class="detail-value">Todas</p>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import Diet from "@/components/models/Diet";
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "User Detail",

  components: {
    Diet,
  },

  data() {
    return {
      deliveryFrequencies: null,
      paymentFrequencies: null,
      franchiseUser: null,
      loading: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "users");

    this.loadUser();
  },

  methods: {
    formatDatetime,

    async loadUser() {
      this.loading = true;

      try {
        this.franchiseUser = await api.users.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: this.$route.name,
          label: this.franchiseUser.name + ' ' + this.franchiseUser.last_name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "users" });
      }

      this.loading = false;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.users.delete(this.franchiseUser.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.$router.push({ name: "usersIndex" });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>